import React from "react";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

import { socialMediasIcons } from "../../utils/socialMediasIcons";
import { formatLocalizedDateTime } from "../../utils/dateTimeUtils";
import usePageFetcher from "../../../repository/usePageFetcher";

import "./style.css";

import mainLogo from "./../../assets/mainLogo.png";

const Footer = () => {
  const { t } = useTranslation();
  const { data } = usePageFetcher("about/");

  const renderSocialMediaLink = [
    "https://t.me/A_Xamzayev",
    "https://facebook.com/abdushukur.hamzaev",
    "https://instagram.com/abdushukurhamzaev",
    "https://youTube.com/c/ecouz",
  ];

  return (
    <div className="footer_wrapper">
      <div className="content_wrapper footer_container">
        <div className="footer_section">
          <img className="footer_image" src={mainLogo} alt="" />
          <p className="footer_image_text">{formatLocalizedDateTime()}</p>
        </div>
        <div className="footer_section">
          <div className="about_box">{t("Sayt haqida")}</div>
          <a
            href="https://ecouz.uz"
            target="_blank"
            rel="noreferrer"
            className="footer_info"
          >
            https://ecouz.uz
          </a>
          <a href="mailto:info@ecouz.uz" className="footer_info">
            info@ecouz.uz
          </a>
          <a
            href="tel:+998955115000"
            className="footer_phone_number working_time"
          >
            +998 (95) 511 50 00
          </a>
          <a
            href="tel:+998955125000"
            className="footer_phone_number working_time"
          >
            +998 (95) 512 50 00
          </a>
        </div>
        <div className="footer_section">
          <div className="about_box">{t("Manzil")}</div>
          <p className="footer_info">{t("ourAddress")}</p>
          <p className="working_time">
            <span>{t("working")}</span> {t("workingDays")}
          </p>
          <p className="working_time">
            <span>{t("workingTimes")}</span> 09:00 - 18:00
          </p>
        </div>

        <div className="footer_section">
          <p className="footer_bold_name">{t("partyLider")}</p>
          <div className="footer_social_media_wrapper">
            {socialMediasIcons.map(({ id, icon }, index) => {
              return (
                <a
                  href={renderSocialMediaLink[index]}
                  target="_blank"
                  className="footer_social_media"
                  key={id}
                  rel="noreferrer"
                >
                  <Icon width={"24px"} icon={icon} />
                </a>
              );
            })}
          </div>
          <p className="footer_bold_name">{t("Biz ijtimoiy tarmoqlarda")}</p>
          <div className="footer_social_media_wrapper">
            {socialMediasIcons.map(({ id, icon, name }, index) => {
              return (
                <a
                  href={data[0]?.[name]}
                  target="_blank"
                  className="footer_social_media"
                  key={id}
                  rel="noreferrer"
                >
                  <Icon width={"24px"} icon={icon} />
                </a>
              );
            })}
          </div>
          <div className="footer_developed_by">
            {t("Developed by")}:
            <a
              href="https://abdullox.uz"
              className="footer_an_icon_wrapper"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                width="621"
                height="692"
                viewBox="0 0 621 692"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M105 691.139C92.6667 691.139 81.8333 690.139 72.5 688.139C63.1667 686.139 55 681.306 48 673.639C41.3333 665.972 38 654.139 38 638.139C38 615.806 44.6667 585.806 58 548.139C71.6667 510.472 89.5 472.639 111.5 434.639C94.8333 435.639 81.6667 438.139 72 442.139C62.3333 446.139 56 452.306 53 460.639C54.3333 460.639 55.6667 462.306 57 465.639C58.6667 468.972 59.5 472.472 59.5 476.139C59.5 482.139 56.8333 486.972 51.5 490.639C46.1667 493.972 39.5 495.639 31.5 495.639C22.1667 495.639 14.6667 493.139 9 488.139C3.33333 483.139 0.5 475.972 0.5 466.639C0.5 455.306 4.83333 444.972 13.5 435.639C22.5 426.306 34.8333 418.972 50.5 413.639C66.1667 407.972 83.5 405.139 102.5 405.139C109.5 405.139 118.167 405.639 128.5 406.639C155.833 363.306 184.667 327.972 215 300.639C245.667 272.972 274.833 259.139 302.5 259.139C318.5 259.139 331.667 261.472 342 266.139L263.5 634.139H191.5L230 452.639C217.667 446.972 206.333 442.806 196 440.139C185.667 437.472 174.667 435.639 163 434.639C144 475.639 128.333 517.639 116 560.639C104 603.306 98 637.472 98 663.139C98 675.806 100.333 685.139 105 691.139ZM263.5 294.639C249.167 302.306 234.167 316.639 218.5 337.639C203.167 358.306 188.167 383.472 173.5 413.139C197.5 417.806 217.833 423.639 234.5 430.639L263.5 294.639Z"
                  fill="white"
                />
                <path
                  d="M331.015 44.441C303.915 54.3199 283.272 69.7328 269.087 90.6796C255.297 111.222 248.552 136.093 248.852 165.291C248.984 178.091 250.505 189.876 253.415 200.646C256.322 211.017 260.41 219.576 265.68 226.322C240.081 226.585 221.029 221.58 208.523 211.308C196.412 200.632 190.244 184.294 190.018 162.296C189.731 134.297 197.663 108.214 213.816 84.047C229.964 59.4798 251.964 39.8528 279.814 25.166C307.665 10.4791 337.989 2.96723 370.788 2.6303C379.987 2.5358 387.993 3.05358 394.805 4.18365C401.617 5.31374 409.439 7.43351 418.271 10.543L493.565 330.786L557.415 4.3133L615.612 3.71546L522.427 453.496L439.631 454.347L366.978 157.478L301.639 455.765L244.642 456.35L331.015 44.441Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
